import { Menu, ScrollArea, Stack, Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

export type DropdownButtonItem = {
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  color?: string;
};

type Props = {
  label: string;
  items: DropdownButtonItem[];
  ariaLabel?: string;
  maxDropdownHeight?: number;
};

export function DropdownButton({ label, items, ariaLabel, maxDropdownHeight = 280 }: Props) {
  return (
    <Menu position="bottom-start" withinPortal>
      <Menu.Target>
        <UnstyledButton
          aria-label={ariaLabel ?? label}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            paddingTop: 3,
            paddingBottom: 3,
            paddingLeft: 8,
            paddingRight: 8,
            borderRadius: 8,
            backgroundColor: 'var(--mantine-color-brand-0)',
          }}
        >
          <Text size="xs" fw={FONT_WEIGHTS.semibold} c="brand.9" style={{ lineHeight: 1.2 }}>
            {label}
          </Text>
          <IconChevronDown size={16} color="var(--mantine-color-brand-9)" />
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown
        style={{
          backgroundColor: 'var(--mantine-color-white)',
          border: '1px solid var(--mantine-color-gray-1)',
          borderRadius: 16,
          boxShadow: 'none',
          paddingTop: 12,
          paddingBottom: 12,
          paddingLeft: 4,
          paddingRight: 4,
        }}
      >
        <ScrollArea.Autosize mah={maxDropdownHeight} type="auto">
          <Stack gap={4}>
            {items.map(item => (
              <Menu.Item
                key={item.label}
                onClick={item.onClick}
                disabled={item.disabled}
                style={{
                  paddingTop: 4,
                  paddingBottom: 4,
                  paddingLeft: 12,
                  paddingRight: 12,
                }}
              >
                <Text size="sm" fw={FONT_WEIGHTS.medium} c={item.color ?? 'black'}>
                  {item.label}
                </Text>
              </Menu.Item>
            ))}
          </Stack>
        </ScrollArea.Autosize>
      </Menu.Dropdown>
    </Menu>
  );
}
